import "./ProfessionalServicesSeo.module.css";
import Header from "@/reusable_sections/Header";
import ConsultantHero from "./sections/ConsultantHero";
import ProfessionalApproach from "./sections/ProfessionalApproach";
import Directory from "./sections/Directory";
import Footer from "@/reusable_sections/Footer";
export default function ProfessionalServicesSeoPage() {
  return <div>
      <Header />
      <ConsultantHero />
      <ProfessionalApproach />
      <Directory />
      <Footer />
    </div>;
}